export const classes = {
  optionsCell: 'options-cell',
  optionsIcon: 'cursor-pointer text-grey-6',
};
